import { gql } from '@apollo/client'

import { LOCATION_LIST_FRAGMENT } from '../fragments'

const UPDATE_LOCATIONS_STATUS_FLAGS_MUTATION = gql`
  mutation updateLocationsStatusFlagsMutation(
    $ids: [ID!]!
    $data: StatusFlagsUpdateInput!
  ) {
    updateLocationsStatusFlags(ids: $ids, data: $data) {
      ...LocationListFragment
    }
  }
  ${LOCATION_LIST_FRAGMENT}
`

export default UPDATE_LOCATIONS_STATUS_FLAGS_MUTATION
